<script setup>
import { AccordionRoot } from 'radix-vue'
</script>

<template>
  <AccordionRoot>
    <slot />
  </AccordionRoot>
</template>
